import React from 'react';
import { Link } from "react-router-dom";
// import { HashLink } from 'react-router-hash-link';

function TopNavigation(props) {
    return (
        <nav className="nav">
            {/* <HashLink to="/#benefits">ABOUT</HashLink> */}
            <Link to="/participants">2021 PARTICIPANTS</Link>
            <Link to="/benefits">BENEFITS</Link>
        </nav>
    );
}

export default TopNavigation;
